var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "390.91px",
    height: "56.907px",
    viewBox: "0 0 390.91 56.907",
    enableBackground: "new 0 0 390.91 56.907",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M53.58,7.824C47.659,2.609,40.21,0,31.229,0c-8.981,0-16.431,2.629-22.35,7.881 C2.958,13.134,0,19.773,0,27.797v29.11h10.533v-9.25v-6.619v-9.412v-2.151v-1.678c0-5.472,1.917-9.904,5.755-13.297 c3.837-3.39,8.819-5.086,14.941-5.086c5.959,0,10.901,1.73,14.819,5.196c3.919,3.465,5.878,7.862,5.878,13.187v3.829H14.238v9.412 h37.688v15.869h10.533v-29.11C62.459,19.699,59.498,13.042,53.58,7.824z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.602,
    y: 16.433,
    fill: "#FFFFFF",
    width: 10.655,
    height: 40.475
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "138.46,45.446 117.846,1.096 107.19,1.096 107.19,56.907 117.846,56.907 117.846,24.021  133.133,56.907 143.788,56.907 159.074,24.019 159.074,56.907 169.729,56.907 169.729,1.096 159.074,1.096  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M266.669,45.58c-1.43-1.275-2.144-2.938-2.144-4.979V1.096h-10.532v39.505 c0,4.744,1.694,8.646,5.081,11.711c3.389,3.063,7.778,4.596,13.167,4.596h45.189v-9.411h-45.189 C269.954,47.496,268.096,46.858,266.669,45.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M239.054,29.11c3.428-3.139,5.143-7.04,5.143-11.708c0-4.599-1.775-8.463-5.326-11.601 c-3.552-3.136-7.859-4.706-12.921-4.706h-43.843v55.812h43.843c5.305,0,9.675-1.532,13.104-4.596 c3.428-3.065,5.143-6.967,5.143-11.711C244.196,36.005,242.481,32.173,239.054,29.11z M225.949,33.706 c2.285,0,4.122,0.622,5.51,1.862c1.389,1.241,2.082,2.918,2.082,5.032c0,1.97-0.714,3.613-2.142,4.926 c-1.43,1.313-3.247,1.97-5.45,1.97h-33.312v-3.272V33.706v-9.411v-4.768v-9.021h33.312c2.285,0,4.122,0.638,5.51,1.914 c1.389,1.278,2.082,2.937,2.082,4.981c0,1.967-0.714,3.609-2.142,4.923c-1.43,1.313-3.247,1.97-5.45,1.97h-29.607v9.411H225.949z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E63044",
    cx: 84.929,
    cy: 6.678,
    r: 5.581
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M345.598,10.507h45.313V1.096h-45.313c-5.063,0-9.39,1.587-12.982,4.76 c-3.593,3.175-5.347,7.023-5.266,11.547v1.2v3.602c0,2.535,0.507,4.821,1.486,6.877c-1.022,2.047-1.53,4.282-1.486,6.718v3.5v1.302 c0,4.744,1.715,8.646,5.144,11.711c3.43,3.063,7.796,4.596,13.104,4.596h45.313v-9.411h-45.313c-2.205,0-4.042-0.656-5.513-1.97 c-1.468-1.313-2.162-2.956-2.082-4.926l0.013-0.667v-0.635v-2.071v-0.762v-0.801c0.03-1.98,0.714-3.599,2.069-4.848 c1.116-1.026,2.538-1.619,4.234-1.819c-1.642-0.212-3.061-0.823-4.234-1.871c-1.416-1.265-2.094-2.846-2.069-4.722v-0.868V20.91 v-2.308v-0.533l-0.013-0.667c0-2.045,0.694-3.703,2.082-4.981C341.474,11.145,343.312,10.507,345.598,10.507z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E63044",
    d: "M358.268,21.537c-3.422,0-6.195,2.875-6.195,6.424c0,3.545,2.773,6.42,6.195,6.42h9.524V21.537H358.268z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M377.317,21.537h-9.525v12.844h9.525c3.422,0,6.195-2.875,6.195-6.42 C383.513,24.412,380.739,21.537,377.317,21.537z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M324.28,33.867c-0.364,0-0.661-0.344-0.661-0.765v-8.044c0-0.421,0.297-0.762,0.661-0.762 c0.365,0,0.66,0.341,0.66,0.762v8.044C324.94,33.523,324.646,33.867,324.28,33.867z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M321.69,37.262c-0.365,0-0.659-0.34-0.659-0.761V21.663c0-0.424,0.294-0.764,0.659-0.764 s0.66,0.34,0.66,0.764v14.838C322.351,36.922,322.056,37.262,321.69,37.262z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M319.102,40.92c-0.366,0-0.661-0.34-0.661-0.764V18.005c0-0.421,0.295-0.764,0.661-0.764 c0.364,0,0.659,0.343,0.659,0.764v22.151C319.761,40.58,319.466,40.92,319.102,40.92z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M316.512,44.446c-0.366,0-0.661-0.34-0.661-0.761V14.479c0-0.424,0.295-0.764,0.661-0.764 c0.364,0,0.66,0.34,0.66,0.764v29.207C317.172,44.106,316.876,44.446,316.512,44.446z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f43e2dae437d0b4a66a353b6bfbe96e0.svg";
export { ForwardRef as ReactComponent };